import { LocalStorageKeys } from '@src/enums/localStorageKeys.enum';
import { getAccessToken } from '@src/redux/selectors/accessToken';
import store from '@src/redux';

export const getToken = (): string | undefined => {
  return getAccessToken(store.getState()) || localStorage.getItem(LocalStorageKeys.TOKEN_STORAGE_KEY) || undefined;
};
